import { onlyNumbers, stripCnpjMask } from './onlyNumbers';
import { cpf } from './cpf';
import { cnpj } from './cnpj';

export const cpfOrCnpj = value => {
  const strippedCnpj = stripCnpjMask(value);
  if (!strippedCnpj) {
    return '';
  }
  if (strippedCnpj.length === 14) {
    return cnpj(value);
  }
  const strippedCpf = onlyNumbers(value);
  return cpf(strippedCpf);
};
